import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsOfService() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Terms of Service - Negotrix';
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className={`min-h-screen bg-cipher-black text-white transition-opacity duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <Header />

      <section className="pt-40 pb-24 px-6 lg:px-12 bg-cipher-dark border-b border-gray-900">
        <div className="max-w-[1000px] mx-auto">
          <h2 className="text-sm tracking-widest uppercase text-cipher-hypergreen font-bold mb-6">Legal</h2>
          <h1 className="text-[6vw] leading-[0.9] font-black tracking-tighter mb-8">
            <span className="text-white">Terms of Service</span>
          </h1>
          <p className="text-xl text-gray-400">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </section>

      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-[1000px] mx-auto space-y-12">
          
          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">1. Agreement to Terms</h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              By accessing our website and using our services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
            </p>
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">2. Use License</h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-4">
              Permission is granted to temporarily download one copy of the materials (information or software) on Negotrix's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-400 text-lg">
              <li>Modify or copy the materials;</li>
              <li>Use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
              <li>Attempt to decompile or reverse engineer any software contained on Negotrix's website;</li>
              <li>Remove any copyright or other proprietary notations from the materials; or</li>
              <li>Transfer the materials to another person or "mirror" the materials on any other server.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">3. Disclaimer</h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              The materials on Negotrix's website are provided on an 'as is' basis. Negotrix makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">4. Limitations</h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              In no event shall Negotrix or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Negotrix's website, even if Negotrix or a Negotrix authorized representative has been notified orally or in writing of the possibility of such damage.
            </p>
          </div>

          <div>
            <h2 className="text-3xl font-bold mb-6 text-white">5. Governing Law</h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              These terms and conditions are governed by and construed in accordance with the laws of India and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
            </p>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}